<div
  class="fsx-text-component"
  *ngIf="formControl && visible"
  [ngStyle]="{
    height: height,
    width: width,
    display: visible ? 'block' : 'none',
  }"
  [ngClass]="{
    invalid: formControl.invalid && formControl.touched,
    wrap: overflowWrap,
    readonly: readonly,
  }"
>
  <ng-container *ngIf="!readonly; else readOnly">
    <label>
      {{ caption }}
      <span class="required" *ngIf="required">*</span>
      <mat-icon *ngIf="helpText" [matTooltip]="helpText">info_outline</mat-icon>
    </label>

    <input
      autocomplete="never"
      [formControl]="formControl"
      [placeholder]="hint"
      [ngClass]="{
        invalid: formControl.invalid && formControl.touched,
      }"
      (focus)="onFocus()"
    />

    <div class="errors-container">
      <p
        class="hint-text"
        *ngIf="formControl.touched"
        [ngClass]="{
          invalid: formControl.invalid && formControl.value?.length > 0,
        }"
      >
        {{ formControl.value?.length || 0 }}/{{ maxLength || 0 }}
      </p>
      <p class="error-message">
        {{
          formControl.invalid && formControl.touched ? getErrorMessage() : ""
        }}
      </p>
    </div>
  </ng-container>

  <ng-template #readOnly>
    <p class="readonly-text">{{ formControl.value }}</p>
    <label class="readonly-label">{{ caption }}</label>
  </ng-template>
</div>
